import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12995c12"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex gap-4" }
const _hoisted_2 = { class: "ac-form-control w-full" }
const _hoisted_3 = { for: "batchQuantity" }
const _hoisted_4 = ["step"]
const _hoisted_5 = { class: "ac-form-control w-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "batchUnitPrice" }, "Birim Alış Fiyatı", -1))
const _hoisted_7 = { class: "flex gap-4" }
const _hoisted_8 = { class: "ac-form-control w-full" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "batchCurrency" }, "Para Birimi", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "ac-form-control w-full" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "batchCondition" }, "Durum", -1))
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "ac-form-control w-full" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "batchDate" }, "Alış Tarihi", -1))
const _hoisted_16 = { class: "ac-form-control w-full" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "batchNote" }, "Not", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "optional-label" }, "opsiyonel", -1))
const _hoisted_19 = { class: "flex items-center justify-center gap-6 w-full" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "ac-primary-button text-2xl mt-2"
}, "Parti Ekle", -1))

import { ref } from "vue"
import { currencyOptions, conditionOptions } from "@/composables/inventoryHelpers"
import type { AcInventoryBatch } from "@/types/inventory"


export default /*#__PURE__*/_defineComponent({
  __name: 'inventoryBatchForm',
  props: {
    quantityLabel: {},
    defaultCurrency: {},
    integerOnly: { type: Boolean }
  },
  emits: ["batch-submitted", "cancel"],
  setup(__props: any, { emit: __emit }) {


const props = __props

const emit = __emit

const todayISO = new Date().toISOString().slice(0, 10)

const quantity = ref<number | null>(null)
const unitPrice = ref<number | null>(null)
const purchaseCurrency = ref<NonNullable<AcInventoryBatch["purchaseCurrency"]>>(props.defaultCurrency ?? "TRY")
const condition = ref<NonNullable<AcInventoryBatch["condition"]>>("NEW")
const purchaseDate = ref<string>(todayISO)
const note = ref("")

const submit = () => {
    if (quantity.value === null || isNaN(Number(quantity.value)) || Number(quantity.value) <= 0) {
        alert("Lütfen geçerli bir miktar giriniz.")
        return
    }
    if (props.integerOnly && !Number.isInteger(Number(quantity.value))) {
        alert("Bu ürün adet ile takip edilir; lütfen tam sayı giriniz.")
        return
    }
    if (unitPrice.value === null || isNaN(Number(unitPrice.value)) || Number(unitPrice.value) < 0) {
        alert("Lütfen geçerli bir birim fiyat giriniz.")
        return
    }
    emit("batch-submitted", {
        quantity: Number(quantity.value),
        unitPrice: Number(unitPrice.value),
        purchaseCurrency: purchaseCurrency.value,
        condition: condition.value,
        purchaseDate: new Date(purchaseDate.value),
        note: note.value.trim() || undefined,
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(submit, ["prevent"]),
    class: "ac-main-form !border-none"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, "Miktar" + _toDisplayString(_ctx.quantityLabel ? ` (${_ctx.quantityLabel})` : ''), 1),
        _withDirectives(_createElementVNode("input", {
          id: "batchQuantity",
          type: "number",
          min: "1",
          step: _ctx.integerOnly ? '1' : 'any',
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((quantity).value = $event)),
          required: ""
        }, null, 8, _hoisted_4), [
          [_vModelText, quantity.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          id: "batchUnitPrice",
          type: "number",
          min: "0",
          step: "any",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((unitPrice).value = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, unitPrice.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("select", {
          id: "batchCurrency",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((purchaseCurrency).value = $event)),
          class: "!py-3"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currencyOptions), (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_10))
          }), 128))
        ], 512), [
          [_vModelSelect, purchaseCurrency.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _hoisted_12,
        _withDirectives(_createElementVNode("select", {
          id: "batchCondition",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((condition).value = $event)),
          class: "!py-3"
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(conditionOptions), (opt) => {
            return (_openBlock(), _createElementBlock("option", {
              key: opt.value,
              value: opt.value
            }, _toDisplayString(opt.label), 9, _hoisted_13))
          }), 128))
        ], 512), [
          [_vModelSelect, condition.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          id: "batchDate",
          type: "date",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((purchaseDate).value = $event))
        }, null, 512), [
          [_vModelText, purchaseDate.value]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _withDirectives(_createElementVNode("input", {
        id: "batchNote",
        type: "text",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((note).value = $event))
      }, null, 512), [
        [_vModelText, note.value]
      ]),
      _hoisted_18
    ]),
    _createElementVNode("div", _hoisted_19, [
      _hoisted_20,
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('cancel'))),
        class: "ac-secondary-button text-2xl mt-2"
      }, "İptal")
    ])
  ], 32))
}
}

})